/** Maximum triggered occurrences requested per workspace for the Alerts history surface. */
export const ALERT_HISTORY_OCCURRENCE_LIMIT = 250

/** Triggered rows before this date do not carry chart data reliable enough to render. */
export const ALERT_RELIABLE_CHART_START_DATE = '2026-04-03' as const

/**
 * Stable registry identity; numeric notification-type ids are environment-local. Confirmed against
 * the live `/notifications/subscription/configs/` registry (id 2, "Custom anomaly alerts with
 * thresholds, lookback and filtering") — matches old's hardcoded `2`. `metric_threshold_alert` was
 * this constant's pre-launch proposed value (BE-NTF-01); the backend never adopted it.
 */
export const ALERT_NOTIFICATION_TYPE_NAME = 'anomaly_alert' as const

/** Backend-authored RBAC keys used by the Alerts route and its degraded manage surface. */
export const ALERTS_PERMISSION_KEY = 'alerts' as const
export const ALERTS_MANAGE_PERMISSION_KEY = 'alerts_manage' as const
